export default function capitalizeFirstLetter(value) {
    if (!value) return null;

    const trimmed = value.trim();
    const match = trimmed.match(/\p{L}/u);

    if (!match) return trimmed;

    const firstLetterIndex = match.index;
    return trimmed.slice(0, firstLetterIndex) +
           trimmed[firstLetterIndex].toUpperCase() +
           trimmed.slice(firstLetterIndex + 1);
}